import React from 'react';
import LineagesHero from '../components/lineages/LineagesHero';
import LineagesIntro from '../components/lineages/LineagesIntro';
import FamilyVasquez from '../components/lineages/FamilyVasquez';
import FamilyTanaka from '../components/lineages/FamilyTanaka';
import FamilyOsei from '../components/lineages/FamilyOsei';
import FamilyRivera from '../components/lineages/FamilyRivera';
import LineagesCta from '../components/lineages/LineagesCta';

const LineagesPage = () => (
  <main>
    <LineagesHero />
    <LineagesIntro />
    <FamilyVasquez />
    <FamilyTanaka />
    <FamilyOsei />
    <FamilyRivera />
    <LineagesCta />
  </main>
);

export default LineagesPage;